import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { OeAppService } from './oe-app.service';
import { ProfileService } from './profile.service';
import { Store } from './store';
import { TranslationService } from './translation.service';
import { LinkTypeDto, RegionDataDto } from './types/region-data-dto';

@Injectable({
  providedIn: 'root',
})
export class RegionDataService extends Store<RegionDataDto> {
  constructor(
    private http: HttpClient,
    private oeAppService: OeAppService,
    private profileService: ProfileService,
    private translate: TranslationService
  ) {
    super();
  }

  handleError(error: HttpErrorResponse) {
    return throwError(`${error.error.errorMessage}. - Social media links not activated.`);
  }

  getUserRegionData() {
    this.profileService
      .getContactData()
      .pipe(
        switchMap((contact) => {
          let params = new HttpParams()
            .set('countryCode', contact.address.countryISO)
            .set('languageCode', this.translate.getCurrentLanguage());

          return this.http
            .get<RegionDataDto>(`${this.oeAppService.courseServiceHost}/v1/link-metadata`, { params })
            .pipe(
              catchError(this.handleError),
              tap((data) => {
                if (data !== null) {
                  this.setState(data);
                }
              })
            );
        })
      )
      .subscribe();
  }

  get userRegion$() {
    return this.state$.pipe(
      map((data) => {
        if (!data) {
          return;
        }
        return data.businessRegion;
      })
    );
  }

  get links$() {
    return this.state$.pipe(
      map((data) => {
        if (!data) {
          return;
        }

        let socialMediaLinks = {
          facebookLink: null,
          twitterLink: null,
          youtubeLink: null,
          instagramLink: null,
        };

        let legalLinks = {
          privacyLink: null,
          serviceTermsLink: null,
          termsAndConditionsLink: null,
        };

        data.links.forEach((link) => {
          switch (link.linkType) {
            case LinkTypeDto.FACEBOOK:
              socialMediaLinks.facebookLink = link.url;
              break;
            case LinkTypeDto.TWITTER:
              socialMediaLinks.twitterLink = link.url;
              break;
            case LinkTypeDto.YOUTUBE:
              socialMediaLinks.youtubeLink = link.url;
              break;
            case LinkTypeDto.INSTAGRAM:
              socialMediaLinks.instagramLink = link.url;
              break;

            case LinkTypeDto.PRIVACY_POLICY:
              legalLinks.privacyLink = link.url;
            case LinkTypeDto.SERVICE_TERMS:
              legalLinks.serviceTermsLink = link.url;
            case LinkTypeDto.TERMS_AND_CONDITIONS:
              legalLinks.termsAndConditionsLink = link.url;
          }
        });
        return {socialMediaLinks, legalLinks};
      })
    );
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/region-data.service.ts